// Forms validation

'use strict';

$ice('.needs-validation,[data-bs-toggle*="needs-validation"]', form => {
    form.addEventListener('submit', (e) => {
        if (!form.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
        }

        form.classList.add('was-validated');

    }, false);
})
